






















































































import config from "@/config";
import mixins from "vue-typed-mixins";
import { GeneralMixin } from "@/mixins/general-mixin";
import Snackbar from "@/components/general/snackbar.vue";
import ParticipantMenuBar from "@/components/participant/participant-menu-bar.vue";
import ParticipantFooter from "@/components/participant/participant-footer.vue";
import ParticipantProfileBar from "@/components/participant/participant-profile-bar.vue";
import SuccessModal from "@/components/success-modal.vue";
import GasConsumptionModal from "@/components/general/gas-consumption-modal.vue";
import MeasurementsGeneralContainer from "@/components/participant/dashboard/measurements-general-container.vue";

export default mixins(GeneralMixin).extend({
  name: "ParticipantView",
  components: {
    Snackbar,
    ParticipantMenuBar,
    ParticipantFooter,
    ParticipantProfileBar,
    SuccessModal,
    GasConsumptionModal,
    MeasurementsGeneralContainer,
  },
  computed: {
    getCurrentPageTitle(): string {
      const titles: Record<string, string> = {
        ParticipantDashboard: this.$t("navigation.common.home") as string,
        ParticipantMonitores: this.$t("navigation.common.equipments") as string,
        ParticipantEstatiscas: this.$t(
          "navigation.common.energyConsumption"
        ) as string,
        ParticipantIntervalos: this.$t(
          "navigation.common.consumptionSchedules"
        ) as string,
        ProducaoSolar: this.$t("navigation.common.solarProduction") as string,
        ParticipantLeituras: this.$t(
          "navigation.common.environmentQuality"
        ) as string,
        ParticipantProfile: this.$t("navigation.common.profile") as string,
        "Terms&Conditions": this.$t("common.termsAndConditions") as string,
        SupportPage: this.$t("navigation.common.support") as string,
        ActivityPage: this.$t("navigation.common.activities") as string,
      };

      if (this?.$route?.name === "ParticipantDashboard" && this?.isEv4eu) {
        return `${titles[this?.$route?.name]} - Projeto EV4EU`;
      }

      return this?.$route?.name
        ? titles[this?.$route?.name]
        : "Participant Section";
    },
    isCollapsed(): boolean {
      return this.$store.getters["sidemenuCollapse"];
    },
    showGeneralInformation(): boolean {
      return this?.participantWithAccessOverallInfo ?? false;
    },
  },
  data() {
    return {
      newTaskTitle: config.newTaskTitle,
      newTaskText: config.newTaskText,
      reviewTitle: config.mustReviewTitle,
      reviewText: config.mustReviewText,
      textGas: config.textGasConsumption,
      currentLang: "en",
      languageOptions: [
        {
          label: "EN",
          value: "en",
        },
        {
          label: "PT",
          value: "pt",
        },
      ],
    };
  },
  methods: {
    // // default scroll behaviour on router does not work since we are using a custom one instead
    // scrollBehavior() {
    //   const scrollView = document.getElementById("main-participant-view");
    //   if (scrollView) {
    //     scrollView.scrollTop = 0;
    //   }
    // },
    collapseSidebarMenu(): void {
      this.$store.commit("toggleSidemenuCollapse", !this.isCollapsed);
    },
  },
  // watch: {
  //   $route() {
  //     // setTimeout(this.scrollBehavior, 0);
  //     this.scrollBehavior();
  //   },
  // },
});
